import { toast } from "react-toastify"

import { useCreateMessageTemplateMutation, useLazyGetMessageTemplatesQuery } from "store/api/contractorsApi"
import { ApiTypes, UITypes } from "types"

import getErrorMessage from "utils/getErrorMessage"
import { MessageForm } from "components/form/MessageForm"

export const MessageTemplateCreate = () => {
  const [triggerCreateMessageTemplate] = useCreateMessageTemplateMutation()
  const [triggerGetMessageTemplates] = useLazyGetMessageTemplatesQuery()

  const onCreateTemplate = async (data: UITypes.MessageTemplate) => {
    try {
      const res = await triggerCreateMessageTemplate({
        title: data.title,
        content_plain: data.message,
        content_rich: data.message_rich || "",
        repeat_period: data.frequency as ApiTypes.Model.MessageTemplateFrequency,
      })
      const error = getErrorMessage(res?.error)

      if (error) {
        toast.error(error)
        return false
      } else {
        toast.success("Message template has been successfully created!")
        triggerGetMessageTemplates()
      }
    } catch (error) {
      console.error(error)
      return false
    }
  }

  return <MessageForm onSave={onCreateTemplate} />
}
